<template>
  <div ref="el">
    <Navbar />
    <HomeHeader v-if="page === 'Home'" />
    <Header v-if="!blackList.includes(page)" />
    <router-view id="router-view" />
    <Form
      v-if="
        (page !== 'SMSReservation' && !blackList.includes(page)) ||
        page === 'Home'
      "
    />
    <FloatButtonGroup v-if="showFloatButton" />
    <Footer />
  </div>
</template>

<script setup>
import HomeHeader from '@/components/Home/HomeHeader.vue'
import Navbar from '@/components/Navbar/Navbar.vue'
import Header from '@/components/Headbar/Header.vue'
import Footer from '@/components/Footer/Footer.vue'
import Form from '@/components/Form/Form.vue'
// import FixedPopup from '@/components/Fixed/FixedPopup/FixedPopup.vue'
import { computed, onMounted, ref } from 'vue'
import { useRoute } from 'vue-router'
import FloatButtonGroup from '@/components/FloatButtonGroup.vue'
import { useWindowScroll, useElementSize } from '@vueuse/core'

const { y } = useWindowScroll()
const el = ref(null)
const { height } = useElementSize(el)
const showFloatButton = computed(
  () => y.value > 72 && y.value < height.value * 0.6,
)

const route = useRoute()
const page = computed(() => route.name)
const blackList = [
  'Blog',
  'Article',
  'TagArticle',
  'Policy',
  'PrivacyPolicy',
  'ConsumerRights',
  'MemberTerms',
  'ArticleTest',
  'Home',
  'NotFound',
  'Tutorial',
  'TutorialList',
  'TutorialContent',
]

onMounted(async () => {
  const app = window.document.getElementById('app')
  app.style.paddingBottom = '50px'
})
</script>

<style scoped lang="postcss"></style>
